export const welcome = `
We currently have a team of General Paediatricians and a Paediatric Endocrinologist providing services at our consulting rooms in the Calvary Clinic, Bruce.

Our goal is to provide comprehensive services to the children of Canberra and surrounding districts. We see children from birth through to 16-18 years of age (depending on the condition) and our team each have their own area of interest and expertise.
`;
